import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_BpsAnnual = ({
   itemsRef,
   showErrorFor,
}) => {

   return (
      <form id='RPBS_BpsAnnual' className='file-pdf-document'>
         <div className='file-template'>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Last Bio Psychosocial Date:</span>
                     <input type='date' id='txt_1' name='txt_1' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Annual Bio Physchosocial Date:</span>
                     <input type='date' id='txt_2' name='txt_2' className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'><h3>Section A</h3></p>
            <p className='w-750'>
               <span className='eleHeader'>1. CURRENT PROBLEMS AND PREVIOUS EVALUATIONS/MENTAL HEALTH TREATMENT</span>
               <textarea id='txt_3' name='txt_3' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>2. CURRENT ALCOHOL/DRUG/TOBACCO USAGE AND HISTORY</span>
               <textarea id='txt_4' name='txt_4' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>3. GENDER EXPRESSION AND SEXUAL ORIENTATION</span>
               <textarea id='txt_5' name='txt_5' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>4. MEDICAL HISTORY</span>
               <textarea id='txt_5_1' name='txt_5_1' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>5. FAMILY DYNAMICS (HISTORY AND CURRENT FUNCTIONING)</span>
               <textarea id='txt_5_2' name='txt_5_2' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>6. PHYSICAL/SEXUAL ABUSE HISTORY</span>
               Has the client witnessed a traumatic event? If yes, please specify:<br />
               <textarea id='txt_6' name='txt_6' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               Has the client experienced a traumatic event? If yes, please specify:<br />
               <textarea id='txt_7' name='txt_7' className='add-only'></textarea>
            </p>
            <p className='w-750'><h4>7.School/Employment/Military Information</h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Educational - Highest level Achieved</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_7_1' name='rb_7' className='add-only' value='1' /> Grade School (K-5)
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_7_2' name='rb_7' className='add-only' value='2' /> Middle School
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_7_3' name='rb_7' className='add-only' value='w-750' /> High School, no diploma
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_7_4' name='rb_7' className='add-only' value='4' /> Diploma/ GED
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_7_5' name='rb_7' className='add-only' value='w-750' /> Some College or Technical School
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_7_6' name='rb_7' className='add-only' value='6' /> 2-year college, Associate's Degree
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_7_7' name='rb_7' className='add-only' value='7' /> 4-year college, Bachelor's Degree
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_7_8' name='rb_7' className='add-only' value='8' /> Professional Degree or More
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Educational- current enrollment</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_8_1' name='rb_8' className='add-only' value='1' /> None
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_8_2' name='rb_8' className='add-only' value='2' /> Alternative Learning Program
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_8_3' name='rb_8' className='add-only' value='w-750' /> Academic School (K-12)
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_8_4' name='rb_8' className='add-only' value='4' /> Vocational or Technical School
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_8_5' name='rb_8' className='add-only' value='w-750' /> College
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_8_6' name='rb_8' className='add-only' value='6' /> GED Program
                     Literacy Level:<input type='text' id='txt_9' name='txt_9' className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Need for Assistive Techology:</span>
               <textarea id='txt_10' name='txt_10' className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Occupational</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_11_1' name='rb_11' className='add-only' value='1' /> Full-time work (35 hours/week)
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_11_2' name='rb_11' className='add-only' value='2' /> Part-time work (less than 35 hours/week)
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_11_3' name='rb_11' className='add-only' value='w-750' /> Unemployed and seeking employment
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_11_4' name='rb_11' className='add-only' value='4' /> Unemployed- not seeking employment
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Not labor force and not seeking due to:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_12_1' name='rb_12' className='add-only' value='1' /> Homemaker
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_12_2' name='rb_12' className='add-only' value='2' /> Student
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_12_3' name='rb_12' className='add-only' value='w-750' /> Retired
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_12_4' name='rb_12' className='add-only' value='4' /> Receiving Disability
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_12_5' name='rb_12' className='add-only' value='w-750' /> Incarcerated
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_12_6' name='rb_12' className='add-only' value='6' /> Institutionalized
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_12_7' name='rb_12' className='add-only' value='7' /> Court ordered community service
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_12_8' name='rb_12' className='add-only' value='8' /> Structured day activity
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_12_9' name='rb_12' className='add-only' value='9' /> Unpaid vocational rehabilitation
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rb_12_10' name='rb_12' className='add-only' value='10' /> Volunteer
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rb_12_11' name='rb_12' className='add-only' value='11' /> None
                  </td>
                  <td className='w-375'>&nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Current Employer</span>
                     <input type='text' id='txt_13' name='txt_13' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Current School</span>
                     <input type='text' id='txt_14' name='txt_14' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Position:</span>
                     <input type='text' id='txt_15' name='txt_15' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Disposition towards current work/school:</span>
                     <input type='text' id='txt_16' name='txt_16' className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Identified stressors in the workplace/academic setting:</span>
               <textarea id='txt_17' name='txt_17' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Additional Comments:</span>
               <textarea id='txt_18' name='txt_18' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>8. SOCIAL/ LEGAL/ PSYCHOSEXUAL FUNCTIONING (HOME, FAMILY, PEERS COMMUNITY)</span>
               <textarea id='txt_19' name='txt_19' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>9. CULTURAL AND SPIRITUAL INFORMATION</span>
               <textarea id='txt_20' name='txt_20' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>10. MEDICATION INFORMATION</span>
               Is the client currently prescribed medication?
               <input type='radio' id='rb_21_Y' name='rb_21' className='add-only' value='1' />  Yes &nbsp;
               <input type='radio' id='rb_21_N' name='rb_21' className='add-only' value='0' /> No<br />
               If yes, please complete the chart below:
            </p>
            <p className='w-750'><h4>Current Medications
            </h4></p>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Medication:</span>
                     <input type='text' id='txt_22' name='txt_22' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Dosage:</span>
                     <input type='text' id='txt_23' name='txt_23' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Prescribed by:</span>
                     <input type='text' id='txt_24' name='txt_24' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Compliant:</span>
                     <input type='radio' id='rb_22_1' name='rb_22' className='add-only' value='1' /> Yes &nbsp;
                     <input type='radio' id='rb_22_0' name='rb_22' className='add-only' value='0' /> No
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Efficacy:</span>
                     <input type='text' id='txt_25' name='txt_25' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Side Effects:</span>
                     <input type='text' id='txt_26' name='txt_26' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Current Regimen:</span>
                     <input type='text' id='txt_25_1' name='txt_25_1' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'># of Months on Med:</span>
                     <input type='text' id='txt_26_1' name='txt_26_1' className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Medication:</span>
                     <input type='text' id='txt_27' name='txt_27' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Dosage:</span>
                     <input type='text' id='txt_28' name='txt_28' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Prescribed by:</span>
                     <input type='text' id='txt_29' name='txt_29' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Compliant:</span>
                     <input type='radio' id='rb_30_1' name='rb_30' className='add-only' value='1' /> Yes &nbsp;
                     <input type='radio' id='rb_30_0' name='rb_30' className='add-only' value='0' /> No
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Efficacy:</span>
                     <input type='text' id='txt_31' name='txt_31' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Side Effects:</span>
                     <input type='text' id='txt_32' name='txt_32' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Current Regimen:</span>
                     <input type='text' id='txt_31_1' name='txt_31_1' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'># of Months on Med:</span>
                     <input type='text' id='txt_32_1' name='txt_32_1' className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Medication:</span>
                     <input type='text' id='txt_37' name='txt_37' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Dosage:</span>
                     <input type='text' id='txt_38' name='txt_38' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Prescribed by:</span>
                     <input type='text' id='txt_39' name='txt_39' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Compliant:</span>
                     <input type='radio' id='rb_40_1' name='rb_40' className='add-only' value='1' /> Yes &nbsp;
                     <input type='radio' id='rb_40_0' name='rb_40' className='add-only' value='0' /> No
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Efficacy:</span>
                     <input type='text' id='txt_41' name='txt_41' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Side Effects:</span>
                     <input type='text' id='txt_42' name='txt_42' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Current Regimen:</span>
                     <input type='text' id='txt_41_1' name='txt_41_1' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'># of Months on Med:</span>
                     <input type='text' id='txt_42_1' name='txt_42_1' className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Current Regimen</span>
               <textarea id='txt_33' name='txt_33' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <textarea id='txt_34' name='txt_34' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Number of Months on Medication</span>
               <textarea id='txt_35' name='txt_35' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <textarea id='txt_36' name='txt_36' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>11. SUICIDAL HISTORY AND INFORMATION (BAKER ACTS-HOSPITALIZATIONS</span>
               <textarea id='txt_43' name='txt_43' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>12. SIGNS AND SYMPTOMS THAT SUPPORT DSM DIAGNOSIS (HISTORY OR OBSERVATION)</span>
               <textarea id='txt_44' name='txt_44' className='add-only'></textarea>
            </p>
            <p className='w-750'><h3>Section B</h3></p>
            <p className='w-750'><h3>Suicide Risk Assessment
            </h3></p>
            <p className='w-750'>
               <span className='eleHeader'>1. In the past few weeks, have you wished you were dead?</span>
               <input type='radio' id='rbPastFewWeeks_Yes' name='rbPastFewWeeks' className='add-only' value='1' /> Yes  &nbsp;
               <input type='radio' id='rbPastFewWeeks_No' name='rbPastFewWeeks' className='add-only' value='0' /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>2. In the past few weeks, have you felt that you or your family would be better off if you were dead?</span>
               <input type='radio' id='rbPastFewWeeks1_Yes' name='rbPastFewWeeks1' className='add-only' value='1' /> Yes  &nbsp;
               <input type='radio' id='rbPastFewWeeks1_No' name='rbPastFewWeeks1' className='add-only' value='0' /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>3. In the past week, have you been having thoughts about killing yourself?</span>
               <input type='radio' id='rbPastFewWeeks2_Yes' name='rbPastFewWeeks2' className='add-only' value='1' /> Yes &nbsp;
               <input type='radio' id='rbPastFewWeeks2_No' name='rbPastFewWeeks2' className='add-only' value='0' /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>4. Have you ever tried to kill yourself?</span>
               <input type='radio' id='rbPastFewWeeks3_Yes' name='rbPastFewWeeks3' className='add-only' value='1' /> Yes &nbsp;
               <input type='radio' id='rbPastFewWeeks3_No' name='rbPastFewWeeks3' className='add-only' value='0' /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>If yes, how?</span>
               <textarea id='txtPastFewWeeks' name='txtPastFewWeeks' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               When?<input type='text' id='txtPastFewWeeks1' name='txtPastFewWeeks1' className='add-only' />
            </p>
            <p className='w-750'>
               If the patient answers Yes to any of the above, ask the following acuity question:
            </p>
            <p className='w-750'>
               <span className='eleHeader'>5. Are you having thoughts of killing yourself right now?</span>
               <input type='radio' id='rbPastFewWeeks4_Yes' name='rbPastFewWeeks4' className='add-only' value='1' /> Yes &nbsp;
               <input type='radio' id='rbPastFewWeeks4_No' name='rbPastFewWeeks4' className='add-only' value='0' /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>If yes, please describe:</span>
               <textarea id='txtPastFewWeeks3' name='txtPastFewWeeks3' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <b>If client answers 'No' to all questions 1 through 4, screening is complete ( not necessary to ask question #5). No intervention is necessary (Note: Clinical judgment can always override a negative screen).</b>
            </p>
            <p className='w-750'>
               <b>If client answers 'Yes' to any of questions 1 through 4, or refuses to answer, they are considered a positive screen. Please ask question #5 to assess acuity:</b>
            </p>
            <p className='w-750'>
               <b>'Yes' to question #5 = acute positive screen (imminent risk identified)</b>
            </p>
            <ul>
               <li>Client requires a STAT safety/full mental health evaluation and cannot leave until evaluated for safety. Keep client in sight and client in sight and remove all dangerous objects from room. Alert physician or clinician responsible for client's care.
               </li>
            </ul>
            <p className='w-750'>
               <b>'No' to question #5 = non-acute positive screen (potential risk identified)</b>
            </p>
            <ul>
               <li>Client requires a brief suicide safety assessment to determine if a full mental health evaluation is needed. Client leave until evaluated for safety. Alert physician or clinician responsible for client's care.
               </li>
            </ul>
            <p className='w-750'>
               <b>Please notify RPBHS Clinical Director on the same date of all positive assessments, complete a RPBHS Safety Plan, and advise parent/guardian of positive assessment for all minors.</b>
            </p>
            <p className='w-750'>
               <b>Provide the following resources to all clients:</b>
            </p>
            <p className='w-750'>
               <b>24/7 National Suicide Prevention Lifeline 1-800-273-TALK (8255); En Espanol 1-888-628-9454</b>
            </p>
            <p className='w-750'>
               <b>24/7 Crisis Test Line: Text 'HOME' to 74-74</b>
            </p>
            <p className='w-750'>Please see diagnosis information in the CLIENT INFO section at the top of this document.</p>
            <p className='w-750'><h3>Section C</h3></p>
            <p className='w-750'><h4>CALOCUS and LOCUS
            </h4></p>
            <p className='w-750'><h4>Child/Adolescent Level of Care Worksheet
            </h4></p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>I. Risk of Harm to Self and/or Others
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbSignificant1' name='cbSignificant1' className='add-only' value='1' /> 1. Minimal Risk of Harm
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbSignificant2' name='cbSignificant2' className='add-only' value='1' /> 2. Some Risk of Harm
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbSignificant3' name='cbSignificant3' className='add-only' value='1' /> 3. Significant Risk of Harm
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbSignificant4' name='cbSignificant4' className='add-only' value='1' /> 4. Serious Risk of Harm
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbSignificant5' name='cbSignificant5' className='add-only' value='1' /> 5. Extreme Risk of Harm
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore122' name='txtScore122' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>II. Functional Status
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal17' name='cbMinimal17' className='add-only' value='1' /> 1. Minimal Imairment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal27' name='cbMinimal27' className='add-only' value='1' /> 2. Mild Impairment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal37' name='cbMinimal37' className='add-only' value='1' /> 3. Moderate Impairment
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal47' name='cbMinimal47' className='add-only' value='1' /> 4. Serious Impairment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal57' name='cbMinimal57' className='add-only' value='1' /> 5. Severe Impairment
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore1' name='txtScore1' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>III. Co-Morbidity
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal1' name='cbMinimal1' className='add-only' value='1' /> 1. No Co-Morbidity
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal2' name='cbMinimal2' className='add-only' value='1' /> 2. Minor Co-Morbidity
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal3' name='cbMinimal3' className='add-only' value='1' /> 3. Significant Co-Morbidity
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal4' name='cbMinimal4' className='add-only' value='1' /> 4. Major Co-Morbidity
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal5' name='cbMinimal5' className='add-only' value='1' /> 5. Severe Co-Morbidity
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore2' name='txtScore2' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>IV - A. Recovery Environment - Environmental Stress
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbMinimal10' name='cbMinimal10' className='add-only' value='1' /> 1. Low Stress Environment
                  </td>
                  <td className='w-375'>
                     <input type='checkbox' id='cbMinimal20' name='cbMinimal20' className='add-only' value='1' /> 2. Mildly Stressful Environment
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbMinimal30' name='cbMinimal30' className='add-only' value='1' /> 3. Moderately Stressful Environment
                  </td>
                  <td className='w-375'>
                     <input type='checkbox' id='cbMinimal40' name='cbMinimal40' className='add-only' value='1' /> 4. Highly Stressful Environment
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbMinimal50' name='cbMinimal50' className='add-only' value='1' /> 5. Extremely Stressful Environment
                  </td>
                  <td className='w-375'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore3' name='txtScore3' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>IV - B. Recovery Environment - Environmental Support
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbHighly141' name='cbHighly141' className='add-only' value='1' /> 1. Highly Supportive Environment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbHighly241' name='cbHighly241' className='add-only' value='1' /> 2. Supportive Environment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbHighly251' name='cbHighly251' className='add-only' value='1' /> 3. Limited Support in Environment
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbHighly261' name='cbHighly261' className='add-only' value='1' /> 4. Minimal Support in Environment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbHighly271' name='cbHighly271' className='add-only' value='1' /> 5. No Support in Environment
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore4' name='txtScore4' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>IV. Resiliency and Treatment History
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbFull22' name='cbFull22' className='add-only' value='1' /> 1. Full Resiliency and/or Response to Treatment
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbFull23' name='cbFull23' className='add-only' value='1' /> 2. Significant Resiliency and/or Response to Treatment
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbFull24' name='cbFull24' className='add-only' value='1' /> 3. Moderate Resiliency and/or Response to Treatment
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbFull25' name='cbFull25' className='add-only' value='1' /> 4. Poor Resiliency and/or Response to Treatment
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbFull26' name='cbFull26' className='add-only' value='1' /> 5. Negligible Resiliency and/or Response to Treatment
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore5' name='txtScore5' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>VI-A. Acceptance and Engagement (Child/Adolescent)
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbOptimal' name='cbOptimal' className='add-only' value='1' /> 1. Optimal
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbOptimal1' name='cbOptimal1' className='add-only' value='1' /> 2. Constructive
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbOptimal2' name='cbOptimal2' className='add-only' value='1' /> 3. Obstructive
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbOptimal3' name='cbOptimal3' className='add-only' value='1' /> 4. Adversarial
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbOptimal4' name='cbOptimal4' className='add-only' value='1' /> 5. Inaccessible
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore6' name='txtScore6' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>VI-B. Acceptance and Engagement (Parent/Guardian)
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbConstructive' name='cbConstructive' className='add-only' value='1' /> 1. Optimal
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbConstructive1' name='cbConstructive1' className='add-only' value='1' /> 2. Constructive
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbConstructive2' name='cbConstructive2' className='add-only' value='1' /> 3. Obstructive
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbConstructive3' name='cbConstructive3' className='add-only' value='1' /> 4. Adversarial
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbConstructive4' name='cbConstructive4' className='add-only' value='1' /> 5. Inaccessible
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore7' name='txtScore7' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>Level of Care Recommendation:<input type='text' id='txtScore8' name='txtScore8' className='add-only' />
            </h4></p>
            <p className='w-750'>
               <b>Only include the higest scores on IV-A/IV-B and VI-A & VI-B in your composite score</b>
            </p>
            <p className='w-750'>
               <b>Composite Score:</b>
               <input type='text' id='txtScore9' name='txtScore9' className='add-only' />
            </p>
            <p className='w-750'>
               Please note that the scores are the number indicated next to the rating (1 - 5)
            </p>
            <p className='w-750'><h3>Adult Level of Care Worksheet
            </h3></p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>I. Risk of Harm to Self and/or Others
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbSerious5' name='cbSerious5' className='add-only' value='1' /> 1. Minimal Risk of Harm
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbSerious4' name='cbSerious4' className='add-only' value='1' /> 2. Some Risk of Harm
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbSerious3' name='cbSerious3' className='add-only' value='1' /> 3. Significant Risk of Harm
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbSerious2' name='cbSerious2' className='add-only' value='1' /> 4. Serious Risk of Harm
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbSerious1' name='cbSerious1' className='add-only' value='1' /> 5. Extreme Risk of Harm
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore' name='txtScore' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>II. Functional Status
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal11' name='cbMinimal11' className='add-only' value='1' /> 1. Minimal Imairment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal21' name='cbMinimal21' className='add-only' value='1' /> 2. Mild Impairment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal31' name='cbMinimal31' className='add-only' value='1' /> 3. Moderate Impairment
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal41' name='cbMinimal41' className='add-only' value='1' /> 4. Serious Impairment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMinimal511' name='cbMinimal511' className='add-only' value='1' /> 5. Severe Impairment
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore11' name='txtScore11' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>III. Co-Morbidity
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMorbidity5' name='cbMorbidity5' className='add-only' value='1' /> 1. No Co-Morbidity
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMorbidity4' name='cbMorbidity4' className='add-only' value='1' /> 2. Minor Co-Morbidity
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMorbidity3' name='cbMorbidity3' className='add-only' value='1' /> 3. Significant Co-Morbidity
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMorbidity2' name='cbMorbidity2' className='add-only' value='1' /> 4. Major Co-Morbidity
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMorbidity1' name='cbMorbidity1' className='add-only' value='1' /> 5. Severe Co-Morbidity
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore21' name='txtScore21' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>IV - A. Recovery Environment - Level of Stress
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbMinimal111' name='cbMinimal111' className='add-only' value='1' /> 1. Low Stress Environment
                  </td>
                  <td className='w-375'>
                     <input type='checkbox' id='cbMinimal211' name='cbMinimal211' className='add-only' value='1' /> 2. Mildly Stressful Environment
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbMinimal311' name='cbMinimal311' className='add-only' value='1' /> 3. Moderately Stressful Environment
                  </td>
                  <td className='w-375'>
                     <input type='checkbox' id='cbMinimal411' name='cbMinimal411' className='add-only' value='1' /> 4. Highly Stressful Environment
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbMinimal51' name='cbMinimal51' className='add-only' value='1' /> 5. Extremely Stressful Environment
                  </td>
                  <td className='w-375'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore31' name='txtScore31' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>IV - B. Recovery Environment - Level of Support
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbHighly11' name='cbHighly11' className='add-only' value='1' /> 1. Highly Supportive Environment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbHighly21' name='cbHighly21' className='add-only' value='1' /> 2. Supportive Environment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbHighly22' name='cbHighly22' className='add-only' value='1' /> 3. Limited Support in Environment
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbHighly23' name='cbHighly23' className='add-only' value='1' /> 4. Minimal Support in Environment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbHighly24' name='cbHighly24' className='add-only' value='1' /> 5. No Support in Environment
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore41' name='txtScore41' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>V. Treatment and Recovery History
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbFull2' name='cbFull2' className='add-only' value='1' /> 1. Full Response to Treatment and Recovery Management
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbFull3' name='cbFull3' className='add-only' value='1' /> 2. Significant Response to Treatment and Recovery Management
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbFull4' name='cbFull4' className='add-only' value='1' /> 3. Moderate Response to Treatment and Recovery Management
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbFull5' name='cbFull5' className='add-only' value='1' /> 4. Poor Response to Treatment and Recovery Management
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbFull6' name='cbFull6' className='add-only' value='1' /> 5. Negligible Response to Treatment and Recovery Management
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore51' name='txtScore51' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>VI. Engagement
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Rating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbOptimal211' name='cbOptimal211' className='add-only' value='1' /> 1. Optimal
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbOptimal12' name='cbOptimal12' className='add-only' value='1' /> 2. Constructive
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbOptimal22' name='cbOptimal22' className='add-only' value='1' /> 3. Obstructive
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbOptimal32' name='cbOptimal32' className='add-only' value='1' /> 4. Adversarial
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbOptimal42' name='cbOptimal42' className='add-only' value='1' /> 5. Inaccessible
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Score</b>
               <input type='text' id='txtScore61' name='txtScore61' className='add-only' />
            </p>
            <p className='w-750'><h4>Dimension
            </h4></p>
            <p className='w-750'><h4>Level of Care Recommendation:<input type='text' id='txtScore81' name='txtScore81' className='add-only' />
            </h4></p>
            <p className='w-750'>
               <b>Only include the higest scores on IV-A/IV-B in your composite score</b>
            </p>
            <p className='w-750'>
               <b>Composite Score:</b>
               <input type='text' id='txtScore91' name='txtScore91' className='add-only' />
            </p>
            <p className='w-750'>
               Please note the scores are the number indicated next to the rating (1 - 5)
            </p>
            <p className='w-750'><h3>
               Section D
            </h3></p>
            <p className='w-750'>
               <span className='eleHeader'>Mental Status Examination</span>
               <input type='text' id='txtMentalStatus' name='txtMentalStatus' className='add-only' />
            </p>
            <p className='w-750'><h4>
               Appearance
            </h4></p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Hygiene:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbHygiene1' name='cbHygiene1' className='add-only' value='Hygiene1' /> Clean
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbHygiene2' name='cbHygiene2' className='add-only' value='Hygiene2' /> Neat
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbHygiene3' name='cbHygiene3' className='add-only' value='Hygiene3' /> Disheveled
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbHygiene4' name='cbHygiene4' className='add-only' value='Hygiene4' /> Body Odor
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Facial Expressions:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-125'>
                     <input type='checkbox' id='cbFacial1' name='cbFacial1' className='add-only' value='Facial1' /> Calm
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbFacial2' name='cbFacial2' className='add-only' value='Facial2' /> Sad
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbFacial3' name='cbFacial3' className='add-only' value='Facial3' /> Anxious
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbFacial4' name='cbFacial4' className='add-only' value='Facial4' /> Disgusted
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbFacial5' name='cbFacial5' className='add-only' value='Facial5' /> Angry
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbFacial6' name='cbFacial6' className='add-only' value='Facial6' /> Perplexed
                  </td>
               </tr>

               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Dress:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-125'>
                     <input type='checkbox' id='cbDress1' name='cbDress1' className='add-only' value='Dress1' /> Casual
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbDress2' name='cbDress2' className='add-only' value='Dress2' /> Immaculate
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbDress3' name='cbDress3' className='add-only' value='Dress3' /> Neat
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbDress4' name='cbDress4' className='add-only' value='Dress4' /> Bizarre
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbDress5' name='cbDress5' className='add-only' value='Dress5' /> Inappropriate
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbDress6' name='cbDress6' className='add-only' value='Dress6' /> Dirty
                  </td>
               </tr>

            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Apparent Age:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbApparent1' name='cbApparent1' className='add-only' value='Apparent1' /> Client appears older than their stated age
                  </td>
                  <td className='w-375'>
                     <input type='checkbox' id='cbApparent2' name='cbApparent2' className='add-only' value='Apparent2' /> Client appears younger than their stated age
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Habitus:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbHabitus1' name='cbHabitus1' className='add-only' value='Habitus1' /> Normal
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbHabitus2' name='cbHabitus2' className='add-only' value='Habitus2' /> Underweight
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbHabitus3' name='cbHabitus3' className='add-only' value='Habitus3' /> Overweight
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbHabitus4' name='cbHabitus4' className='add-only' value='Habitus4' /> Obese
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Eye Contact:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbEye1' name='cbEye1' className='add-only' value='Eye1' /> Appropriate
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbEye2' name='cbEye2' className='add-only' value='Eye2' /> Decreased
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbEye3' name='cbEye3' className='add-only' value='Eye3' /> Heightened
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbEye4' name='cbEye4' className='add-only' value='Eye4' /> Avoidant
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Orofacial Dyskinesia:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbOrofacial1' name='cbOrofacial1' className='add-only' value='Orofacial1' /> Grimacing
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbOrofacial2' name='cbOrofacial2' className='add-only' value='Orofacial2' /> Tongue writhing
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbOrofacial3' name='cbOrofacial3' className='add-only' value='Orofacial3' /> Lip smacking
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbOrofacial4' name='cbOrofacial4' className='add-only' value='Orofacial4' /> Lip pursing
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbOrofacial5' name='cbOrofacial5' className='add-only' value='Orofacial5' /> Chewing
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Motor Activity:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMotor1' name='Motor1' className='add-only' value='Motor1' /> Normal activity
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMotor2' name='cbMotor2' className='add-only' value='Motor2' /> Decreased activity
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMotor3' name='cbMotor3' className='add-only' value='Motor3' /> Restlessness
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMotor4' name='cbMotor4' className='add-only' value='Motor4' /> Tension
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMotor5' name='cbMotor5' className='add-only' value='Motor5' /> Agitation
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Movements:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-125'>
                     <input type='checkbox' id='cbMovements1' name='cbMovements1' className='add-only' value='Movements1' /> Tics
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbMovements2' name='cbMovements2' className='add-only' value='Movements2' /> Twitches
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbMovements3' name='cbMovements3' className='add-only' value='Movements3' /> Tremor
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbMovements4' name='cbMovements4' className='add-only' value='Movements4' /> Mannerisms
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbMovements5' name='cbMovements5' className='add-only' value='Movements5' /> Stereotypies
                  </td>
                  <td className='w-125'>
                     <input type='checkbox' id='cbMovements6' name='cbMovements6' className='add-only' value='Movements6' /> Posturing
                  </td>
               </tr>

            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Gait:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbGait1' name='cbGait1' className='add-only' value='Gait1' /> Unsteady
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbGait2' name='cbGait2' className='add-only' value='Gait2' /> Limp
                  </td>
                  <td className='w-100'>
                     <input type='checkbox' id='cbGait3' name='cbGait3' className='add-only' value='Gait3' /> Shuffle
                  </td>
                  <td className='w-350'>
                     <input type='checkbox' id='cbGait4' name='cbGait4' className='add-only' value='Gait4' /> Uses a cane, crutches, or other assistive device
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Cooperativeness & Attitude:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude1' name='cbAttitude1' className='add-only' value='Attitude1' /> Evasive
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude2' name='cbAttitude2' className='add-only' value='Attitude2' /> Guarded
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude3' name='cbAttitude3' className='add-only' value='Attitude3' /> Playful
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude4' name='cbAttitude4' className='add-only' value='Attitude4' /> Ingratiating
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude5' name='cbAttitude5' className='add-only' value='Attitude5' /> Passive
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude6' name='cbAttitude6' className='add-only' value='Attitude6' /> Sullen
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude7' name='cbAttitude7' className='add-only' value='Attitude7' /> Withdrawn
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude8' name='cbAttitude8' className='add-only' value='Attitude8' /> Manipulative
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude9' name='cbAttitude9' className='add-only' value='Attitude9' /> Demanding
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude010' name='cbAttitude10' className='add-only' value='Attitude10' /> Hostile
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude11' name='cbAttitude11' className='add-only' value='Attitude11' /> Overly friendly
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude12' name='cbAttitude12' className='add-only' value='Attitude12' /> Relaxed
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude13' name='cbAttitude13' className='add-only' value='Attitude13' /> Open
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude14' name='cbAttitude14' className='add-only' value='Attitude14' /> Shy
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude15' name='cbAttitude15' className='add-only' value='Attitude15' /> Candid
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttitude16' name='cbAttitude16' className='add-only' value='Attitude16' /> Suspicious
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Speech & Language:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech1' name='cbSpeech1' className='add-only' value='Speech1' /> Accent
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech2' name='cbSpeech2' className='add-only' value='Speech2' /> Stutter
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech3' name='cbSpeech3' className='add-only' value='Speech3' /> Lisp
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech4' name='cbSpeech4' className='add-only' value='Speech4' /> Soft
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech5' name='cbSpeech5' className='add-only' value='Speech5' /> Loud
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech6' name='cbSpeech6' className='add-only' value='Speech6' /> Mute
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech7' name='cbSpeech7' className='add-only' value='Speech7' /> Normal
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech8' name='cbSpeech8' className='add-only' value='Speech8' /> Slow
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech9' name='cbSpeech9' className='add-only' value='Speech9' /> Fast
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech10' name='cbSpeech10' className='add-only' value='Speech10' /> Delayed onset
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech11' name='cbSpeech11' className='add-only' value='Speech11' /> Loquacious
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech12' name='cbSpeech12' className='add-only' value='Speech12' /> Fluent
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech13' name='cbSpeech13' className='add-only' value='Speech13' /> Impoverished
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech14' name='cbSpeech14' className='add-only' value='Speech14' /> Articulate
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech15' name='cbSpeech15' className='add-only' value='Speech15' /> Slurred
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech16' name='cbSpeech16' className='add-only' value='Speech16' /> Monotone
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbSpeech17' name='cbSpeech17' className='add-only' value='Speech17' /> Dysarthria
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Mood:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMood1' name='cbMood1' className='add-only' value='Mood1' /> Depressed
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMood2' name='cbMood2' className='add-only' value='Mood2' /> Sad
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMood3' name='cbMood3' className='add-only' value='Mood3' /> Angry
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMood4' name='cbMood4' className='add-only' value='Mood4' /> Irritable
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMood5' name='cbMood5' className='add-only' value='Mood5' /> Good
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMood6' name='cbMood6' className='add-only' value='Mood6' /> Fantastic
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Affect:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAffect1' name='cbAffect1' className='add-only' value='Affect1' /> Euthymic
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAffect2' name='cbAffect2' className='add-only' value='Affect2' /> Depressed
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAffect5' name='cbAffect5' className='add-only' value='Affect5' /> Elated
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAffect3' name='cbAffect3' className='add-only' value='Affect3' /> Euphoric
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAffect4' name='cbAffect4' className='add-only' value='Affect4' /> Anxious
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAffect6' name='cbAffect6' className='add-only' value='Affect6' /> Irritable
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAffect7' name='cbAffect7' className='add-only' value='Affect7' /> Angry
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Range:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRange1' name='cbRange1' className='add-only' value='Range1' /> Flat
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRange2' name='cbRange2' className='add-only' value='Range2' /> Broad
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRange3' name='cbRange3' className='add-only' value='Range3' /> Blunted
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRange4' name='cbRange4' className='add-only' value='Range4' /> Labile
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRange5' name='cbRange5' className='add-only' value='Range5' /> Restricted
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRange6' name='cbRange6' className='add-only' value='Range6' /> Anhedonic
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'><h4>
               Congruency
            </h4></p>
            <p className='w-750'>
               <span className='eleHeader'>Client's affect is congruent to their mood</span>
               <input type='radio' id='rbClient_Yes' name='rbClient' className='add-only' value='1' /> Yes&nbsp;
               <input type='radio' id='rbClient_No' name='rbClient' className='add-only' value='0' /> No
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Thought Process:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought1' name='cbThought1' className='add-only' value='Thought1' /> Goal-directed
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought2' name='cbThought2' className='add-only' value='Thought2' /> Impoverished
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought3' name='cbThought3' className='add-only' value='Thought3' /> Rapid
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought4' name='cbThought4' className='add-only' value='Thought4' /> Illogical
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought5' name='cbThought5' className='add-only' value='Thought5' /> Incoherent
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought6' name='cbThought6' className='add-only' value='Thought6' /> Distractible
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought7' name='cbThought7' className='add-only' value='Thought7' /> Blocking
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought8' name='cbThought8' className='add-only' value='Thought8' /> Circumstantial
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought9' name='cbThought9' className='add-only' value='Thought9' /> Perseverative
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought10' name='cbThought10' className='add-only' value='Thought10' /> Tangential
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought11' name='cbThought11' className='add-only' value='Thought11' /> Loose
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbThought12' name='cbThought12' className='add-only' value='Thought12' /> Flight of ideas
                  </td>
                  <td className='w-450'>
                     <input type='checkbox' id='cbThought13' name='cbThought13' className='add-only' value='Thought13' /> Disorganized 'Word Salad'
                  </td>

               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Thought Content:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbContent1' name='cbContent1' className='add-only' value='Content1' /> Suicidal ideation
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbContent6' name='cbContent6' className='add-only' value='Content6' /> Worries
                  </td>

                  <td className='w-150'>
                     <input type='checkbox' id='cbContent9' name='cbContent9' className='add-only' value='Content9' /> Ruminations
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbContent9' name='cbContent9' className='add-only' value='Content9' /> Ruminations
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbContent4' name='cbContent4' className='add-only' value='Content4' /> Distortions
                  </td>

               </tr>
               <tr>

                  <td className='w-187'>
                     <input type='checkbox' id='cbContent5' name='cbContent5' className='add-only' value='Content5' /> Obsessions
                  </td>
                  <td className='w-187'>
                     <input type='checkbox' id='cbContent2' name='cbContent2' className='add-only' value='Content2' /> Homicidal ideation
                  </td>

                  <td className='w-187'>
                     <input type='checkbox' id='cbContent7' name='cbContent7' className='add-only' value='Content7' /> Compulsions
                  </td>
                  <td className='w-187'>
                     <input type='checkbox' id='cbContent8' name='cbContent8' className='add-only' value='Content8' /> Phobias
                  </td>
               </tr>
               <tr>

                  <td className='w-750'>
                     <input type='checkbox' id='cbContent3' name='cbContent3' className='add-only' value='Content3' /> Grandiose, somatic, or paranoid delusions
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Perception</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbPerception1' name='cbPerception1' className='add-only' value='Perception1' /> No hallucinations
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbPerception2' name='cbPerception2' className='add-only' value='Perception2' /> Auditory hallucinations
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbPerception3' name='cbPerception3' className='add-only' value='Perception3' /> Auditory command hallucinations
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbPerception4' name='cbPerception4' className='add-only' value='Perception4' /> Visual hallucinations
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbPerception5' name='cbPerception5' className='add-only' value='Perception5' /> Tactile hallucinations
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbPerception6' name='cbPerception6' className='add-only' value='Perception6' /> Olfactory hallucinations
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbPerception7' name='cbPerception7' className='add-only' value='Perception7' /> Gustatory hallucinations
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbPerception8' name='cbPerception8' className='add-only' value='Perception8' /> Illusions
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbPerception9' name='cbPerception9' className='add-only' value='Perception9' /> Derealization or feeling detached from surroundings
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbPerception10' name='cbPerception10' className='add-only' value='Perception10' /> Depersonalization or feeling detached from oneself
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Alertness:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAlertness1' name='cbAlertness1' className='add-only' value='Alertness1' /> Alert
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAlertness2' name='cbAlertness2' className='add-only' value='Alertness2' /> Lethrargic
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAlertness3' name='cbAlertness3' className='add-only' value='Alertness3' /> Obtunded
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAlertness4' name='cbAlertness4' className='add-only' value='Alertness4' /> Comatose
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Attention:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttention1' name='cbAttention1' className='add-only' value='Attention1' /> Normal
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbAttention2' name='cbAttention2' className='add-only' value='Attention2' /> Distracted
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Impulse Control:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbImpulse1' name='cbImpulse1' className='add-only' value='Impulse1' /> Normal
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbImpulse2' name='cbImpulse2' className='add-only' value='Impulse2' /> Impaired
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Orientation:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbOrientation1' name='cbOrientation1' className='add-only' value='Orientation1' /> Name
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbOrientation2' name='cbOrientation2' className='add-only' value='Orientation2' /> Location
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbOrientation3' name='cbOrientation3' className='add-only' value='Orientation3' /> Date
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbOrientation4' name='cbOrientation4' className='add-only' value='Orientation4' /> Time
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Insight:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbInsight1' name='cbInsight1' className='add-only' value='Insight1' /> Good
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbInsight2' name='cbInsight2' className='add-only' value='Insight2' /> Fair
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbInsight3' name='cbInsight3' className='add-only' value='Insight3' /> Poor
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Motivation:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMotivation1' name='cbMotivation1' className='add-only' value='Motivation1' /> Good
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMotivation2' name='cbMotivation2' className='add-only' value='Motivation2' /> Fair
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbMotivation3' name='cbMotivation3' className='add-only' value='Motivation3' /> Poor
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Memory</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMemory1' name='cbMemory1' className='add-only' value='Memory1' /> No impairment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMemory2' name='cbMemory2' className='add-only' value='Memory2' /> Short-term impairment
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbMemory3' name='cbMemory3' className='add-only' value='Memory3' /> Long-term impairment
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Judgment</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbJudgment1' name='cbJudgment1' className='add-only' value='Judgment1' /> Good
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbJudgment2' name='cbJudgment2' className='add-only' value='Judgment2' /> Fair
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbJudgment3' name='cbJudgment3' className='add-only' value='Judgment3' /> Poor
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Reliability</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='checkbox' id='cbReliability1' name='cbReliability1' className='add-only' value='Reliability1' /> Good
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbReliability2' name='cbReliability2' className='add-only' value='Reliability2' /> Fair
                  </td>
                  <td className='w-250'>
                     <input type='checkbox' id='cbReliability3' name='cbReliability3' className='add-only' value='Reliability3' /> Poor
                  </td>
               </tr>
            </table>
            <p className='w-750'><h3>Section E
            </h3></p>
            <p className='w-750'>
               <span className='eleHeader'>Summary of findings</span>
               <textarea id='txtSummaryFindings' name='txtSummaryFindings' className='add-only'></textarea>
            </p>
            <p className='w-750'><h3>Section F
            </h3></p>
            <p className='w-750'><span className='eleHeader'>Updated Treatment Recommendations</span></p>
            <p className='w-750'>Based on this Assessment/Evaluatiopn Interview, this Person Served:</p>
            <table>
               <tr>
                  <td className='w-750'> <input type='radio' id='rb_47_1' name='rb_47' className='add-only' value='1' /> DOES NOT MEET DIAGNOSTIC CRITERIA and is not elgible for Community
                     Mental Health Services, Therefore this Person Served will be: </td>
               </tr>
               <tr>
                  <td className='w-30'>&nbsp;</td>
                  <td className='w-720'><input type='radio' id='rb_48_1' name='rb_48' className='add-only' value='1' /> Discharged</td>
               </tr>
               <tr>
                  <td className='w-30'>&nbsp;</td>
                  <td className='w-720'>
                     <input type='radio' id='rb_48_2' name='rb_48' className='add-only' value='2' /> Transferred to another program-Specify:
                     <input type='text' id='txt_49' name='txt_49' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-30'>&nbsp;</td>
                  <td className='w-720'>
                     <input type='radio' id='rb_48_3' name='rb_48' className='add-only' value='w-750' /> Other/Referrals:
                     <input type='text' id='txt_50' name='txt_50' className='add-only' />
                  </td>
               </tr>
            </table>
 
            <table>
               <tr>
                  <td className='w-750'><input type='radio' id='rb_49_1' name='rb_47' className='add-only' value='1' /> Meets Diagnostic Criteria for (limited
                     to ICD-9 diagnoses of 290 through 298.9,300 through 301.9, 302.7, 303 though 312.4 and 312.81 through
                     314.9, 315.3, 315.31, 315.5, 315.8 and 315.9) </td>
               </tr>
               <tr>
                  <td className='w-30'>&nbsp;</td>
                  <td className='w-310'>
                     <input type='checkbox' id='cb_50' name='cb_50' className='add-only' value='1' /> Brief Behavior Health Exam
                  </td>
                  <td className='w-310'>
                     <input type='checkbox' id='cb_51' name='cb_51' className='add-only' value='1' /> Individual/Family Therapy
                  </td>
               </tr>
               <tr>
                  <td className='w-30'>&nbsp;</td>
                  <td className='w-310'>
                     <input type='checkbox' id='cb_52' name='cb_52' className='add-only' value='1' /> Psychiatric Evaluation
                  </td>
                  <td className='w-310'>
                     <input type='checkbox' id='cb_54' name='cb_54' className='add-only' value='1' /> Medication Management
                  </td>
               </tr>
               <tr>
                  <td className='w-30'>&nbsp;</td>
                  <td className='w-310'>
                     <input type='checkbox' id='cb_55' name='cb_55' className='add-only' value='1' /> Community Support Services (PSR)
                  </td>
                  <td className='w-310'>
                     <input type='checkbox' id='cb_56' name='cb_56' className='add-only' value='1' /> An In-Depth Assessment
                  </td>
               </tr>
               <tr>
                  <td className='w-30'>&nbsp;</td>
                  <td className='w-310'>
                     <input type='checkbox' id='cb_57' name='cb_57' className='add-only' value='1' /> TBOS-Therapy
                  </td>
               </tr>
               <tr>
                  <td className='w-30'>&nbsp;</td>
                  <td className='w-310'>
                     <input type='checkbox' id='cb_60' name='cb_60' className='add-only' value='1' /> Other:
                     <input type='text' id='txt_61' name='txt_61' className='add-only' />
                  </td>
               </tr>
            </table> 
            <p className='w-750'><h3>Section G
            </h3></p>
            <p className='w-750'><h3>Discharge/Transition/After-Care Plan
            </h3></p>
            <p className='w-750'><span className='eleHeader'>Medication Management Needs</span></p>

            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence1' id='chkTherapistPresence1' className='add-only' value='TherapistPresence1' /> Therapist Will Be Assigned/Therapist Responsible Party
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence2' id='chkTherapistPresence2' className='add-only' value='TherapistPresence2' /> Client requests Medication Management Services
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence3' id='chkTherapistPresence3' className='add-only' value='TherapistPresence3' /> Medication education needed (e.g., drug dosage, time and how to take)<input type='text' id='txtDrugDosage' name='txtDrugDosage' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence4' id='chkTherapistPresence4' className='add-only' value='TherapistPresence4' /> Medication compliance and efficacy (if currently taking medication)
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence5' id='chkTherapistPresence5' className='add-only' value='TherapistPresence5' /> Special requests (e.g., laboratory testing requested)<input type='text' id='txtDrugDosage1' name='txtDrugDosage1' className='add-only' />
            </p>
            <p className='w-750'><span className='eleHeader'>Activities of Daily Living Needs</span></p>

            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence6' id='chkTherapistPresence6' className='add-only' value='TherapistPresence6' /> CSC Will be Assigned/CSC Responsible Party
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence7' id='chkTherapistPresence7' className='add-only' value='TherapistPresence7' /> Hygiene Skills<input type='text' id='txtDrugDosage2' name='txtDrugDosage2' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence8' id='chkTherapistPresence8' className='add-only' value='TherapistPresence8' /> Safety Skills<input type='text' id='txtDrugDosage3' name='txtDrugDosage3' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence9' id='chkTherapistPresence9' className='add-only' value='TherapistPresence9' /> Salf-Care Skills<input type='text' id='txtDrugDosage4' name='txtDrugDosage4' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence10' id='chkTherapistPresence10' className='add-only' value='TherapistPresence10' /> Pre-Vocational/Vocational Skills<input type='text' id='txtDrugDosage5' name='txtDrugDosage5' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence11' id='chkTherapistPresence11' className='add-only' value='TherapistPresence11' /> Educational Skills<input type='text' id='txtDrugDosage6' name='txtDrugDosage6' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence12' id='chkTherapistPresence12' className='add-only' value='TherapistPresence12' /> Financial Planning/Money Management Skills<input type='text' id='txtDrugDosage7' name='txtDrugDosage7' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence13' id='chkTherapistPresence13' className='add-only' value='TherapistPresence13' /> Healthy Meal Planning/Preparation Skills<input type='text' id='txtDrugDosage8' name='txtDrugDosage8' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence14' id='chkTherapistPresence14' className='add-only' value='TherapistPresence14' /> Appropriate Use of Community Resources Skills<input type='text' id='txtDrugDosage9' name='txtDrugDosage9' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence15' id='chkTherapistPresence15' className='add-only' value='TherapistPresence15' /> Healthy Communication/Boundary Setting Skills<input type='text' id='txtDrugDosage10' name='txtDrugDosage10' className='add-only' />
            </p>
            <p className='w-750'><span className='eleHeader'>Referrals/Community Resource Information Needs</span></p>

            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence16' id='chkTherapistPresence16' className='add-only' value='TherapistPresence16' /> TCM Will be Assigned/TCM Responsible Party
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence17' id='chkTherapistPresence17' className='add-only' value='TherapistPresence17' /> Psychiatrist
               <input type='text' id='txtDrugDosage17' name='txtDrugDosage17' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence18' id='chkTherapistPresence18' className='add-only' value='TherapistPresence18' /> Community Mental Health Center/Agency
               <input type='text' id='txtDrugDosage18' name='txtDrugDosage18' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence19' id='chkTherapistPresence19' className='add-only' value='TherapistPresence19' /> Inpatient Treatment (Mental Health)
               <input type='text' id='txtDrugDosage19' name='txtDrugDosage19' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence20' id='chkTherapistPresence20' className='add-only' value='TherapistPresence20' />
               Inpatient Treatment (Substance Abuse)<input type='text' id='txtDrugDosage20' name='txtDrugDosage20' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence21' id='chkTherapistPresence21' className='add-only' value='TherapistPresence21' />
               Outpatient Substance Use Treatment<input type='text' id='txtDrugDosage21' name='txtDrugDosage21' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence22' id='chkTherapistPresence22' className='add-only' value='TherapistPresence22' />
               Support Group<input type='text' id='txtDrugDosage22' name='txtDrugDosage22' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence23' id='chkTherapistPresence23' className='add-only' value='TherapistPresence23' />
               Day Treatment<input type='text' id='txtDrugDosage23' name='txtDrugDosage23' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence24' id='chkTherapistPresence24' className='add-only' value='TherapistPresence24' />
               Peer Support<input type='text' id='txtDrugDosage24' name='txtDrugDosage24' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence25' id='chkTherapistPresence25' className='add-only' value='TherapistPresence25' />
               Case Management<input type='text' id='txtDrugDosage25' name='txtDrugDosage25' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence26' id='chkTherapistPresence26' className='add-only' value='TherapistPresence26' />
               Outpatient Substance Use Treatment<input type='text' id='txtDrugDosage26' name='txtDrugDosage26' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence27' id='chkTherapistPresence27' className='add-only' value='TherapistPresence27' />
               Transportation Needs<input type='text' id='txtDrugDosage27' name='txtDrugDosage27' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence28' id='chkTherapistPresence28' className='add-only' value='TherapistPresence28' />
               Financial Assistance Needs<input type='text' id='txtDrugDosage28' name='txtDrugDosage28' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence29' id='chkTherapistPresence29' className='add-only' value='TherapistPresence29' />
               Food Resources<input type='text' id='txtDrugDosage29' name='txtDrugDosage29' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence30' id='chkTherapistPresence30' className='add-only' value='TherapistPresence30' />
               All referrals will include contact information, hours of operation, and services offered
            </p>
            <p className='w-750'><span className='eleHeader'>Housing Needs</span></p>

            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPresence31' id='chkTherapistPresence31' className='add-only' value='TherapistPresence31' />
               TCM Will Be Assigned/TCM Responsible Party
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPre1' id='chkTherapistPre1' className='add-only' value='TherapistPre1' />
               Client has stable housing at the time of intake<input type='text' id='txtDrugDos1' name='txtDrugDos1' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPre2' id='chkTherapistPre2' className='add-only' value='TherapistPre2' />
               Housing referral provided or housing plan will be created<input type='text' id='txtDrugDos2' name='txtDrugDos2' className='add-only' />
            </p>
            <p className='w-750'><span className='eleHeader'>Natural Supports </span></p>

            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPre3' id='chkTherapistPre3' className='add-only' value='TherapistPre3' />
               TCM Will Be Assigned/TCM Responsible Party
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPre4' id='chkTherapistPre4' className='add-only' value='TherapistPre4' />
               Client reports b natural supports present<input type='text' id='txtDrugDos4' name='txtDrugDos4' className='add-only' />
            </p>
            <p className='w-750'><span className='eleHeader'>Safety Planning </span></p>

            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPre5' id='chkTherapistPre5' className='add-only' value='TherapistPre5' />
               TCM Will Be Assigned/Therapist Responsible Party
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPre6' id='chkTherapistPre6' className='add-only' value='SafetyPlanCompletedAtIntake6' />
               Safety Plan Completed at Intake
            </p>
            <p className='w-750'><span className='eleHeader'>Discharge Criteria</span></p>

            <p className='w-750'>
               Client will be discharged from therapy services
            </p>
            <p className='w-750'>
               when<input type='text' id='txtDrugDos5' name='txtDrugDos5' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPre7' id='chkTherapistPre7' className='add-only' value='TherapistPre7' />
               Client will not be enrolled in therapy services
            </p>
            <p className='w-750'>
               Client will be discharged from PSR services
            </p>
            <p className='w-750'>
               when<input type='text' id='txtDrugDos6' name='txtDrugDos6' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPre8' id='chkTherapistPre8' className='add-only' value='TherapistPre8' />
               Client will not be enrolled in PSR services
            </p>
            <p className='w-750'>
               Client will be discharged from TCM services
            </p>
            <p className='w-750'>
               when<input type='text' id='txtDrugDos8' name='txtDrugDos8' className='add-only' />
            </p>
            <p className='w-750'>
               <input type='checkbox' name='chkTherapistPre9' id='chkTherapistPre9' className='add-only' value='TherapistPre9' />
               Client will not be enrolled in TCM services
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Notes:</span>
               <textarea id='txtNotes' name='txtNotes' className='add-only'></textarea>
            </p>
            <p className='w-750'><h3>Section H
            </h3></p>
            <p className='w-750'><span className='eleHeader'>Diagnostic Impressions</span></p>

            <p className='w-750'>
               Please note that a previous diagnosis provided by a M.D/Ph.D.,or ARNP may not be changed by a LPHA, MLP, or BLP and a previous diagnosis provided by a LPHA may not be changed by a MLP or BLP
            </p>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>DSM - 5 </span><span className='small block'>(e.g., 314.02):</span>
                     <input type='text' id='txtDocumentClientsNameDsm' name='txtDocumentClientsNameDsm' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>ICD - 10 </span><span className='small block'>(e.g., F90.2):</span>
                     <input type='text' id='txtDocumentMedicaidNoIcd' name='txtDocumentMedicaidNoIcd' className='add-only' />
                  </td>
               </tr>
            </table>




         </div>
      </form>

   )
}











